export { default as ChatWidget } from "./App";
export { initChatbot } from "./main";

if (typeof window !== "undefined") {
  import("./main").then(({ initChatbot }) => {
    (window as any).ChatbotWidget = {
      initChatbot,
    };
  });
}
